import React from 'react'
import { DateRange } from 'react-date-range'
import moment from 'moment'
import Popover from '../../../containers/Popovers/components/Popover'
import styles from './CustomReportDatePopover.css'

const CustomReportDatePopover = props => {
  const {
    updateCustomReportRequest,
    postReportRequest,
    handleOnOutsidePopoverClick,
    min,
    max,
    dateRange,
  } = props

  const requestReport = () => {
    postReportRequest()
  }

  const getButton = () => {
    const dayDiff = moment(dateRange.endDate).diff(dateRange.startDate, 'days')
    if (!moment(dateRange.startDate).isSame(dateRange.endDate) && dayDiff > 13 && dayDiff < 101) {
      return (
        <button
          className={styles.exportBtnExtraMarg}
          onClick={requestReport}
        >
          Download
        </button>
      )
    } else {
      return (
        <div>
          <div className={styles.message}>
            Selection must be between 14 and 100 days.
          </div>
          <button
            className={styles.exportBtn}
            disabled
          >
            Download
          </button>
        </div>
      )
    }
  }

  return (
    <Popover
      className={styles.datePopover}
      onOutsidePopoverClick={handleOnOutsidePopoverClick}
    >
      <div className={styles.instructions}>Select time period for a custom report</div>
      <DateRange
        ranges={[
          {
            key: 'selection',
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
          },
        ]}
        onChange={dates => updateCustomReportRequest(dates.selection)}
        shownDate={dateRange.endDate}
        minDate={min}
        maxDate={max}
        moveRangeOnFirstSelection={false}
      />
      {getButton()}
    </Popover>
  )
}

export default CustomReportDatePopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/CustomReportDatePopover/CustomReportDatePopover.jsx